//App
import { SettingApiType } from "./types/apiTypes";
import apiClient from "../../apiClient/apiClient";
import endPoints from "./endPoints";

const settingApi: SettingApiType = {
  get: (value) => apiClient.get(endPoints.setting.get(value)),
  getAll: (payload) => apiClient.get(endPoints.setting.getAll(), payload),
  save: (payload) => apiClient.post(endPoints.setting.save(), payload),
  delete: (value) => apiClient.delete(endPoints.setting.delete(value)),
  activate: (value) => apiClient.post(endPoints.setting.activate(value)),
  deactivate: (value) => apiClient.post(endPoints.setting.deActivate(value)),
  searchSettings: (payload) =>
    apiClient.post(endPoints.setting.searchSettings(), payload),
};

export default settingApi;
